module.exports = __webpack_public_path__ + "static/frontUserNew/img/logo.b5d4b80e.png";